/** The four day states the server sends. The client renders them and never derives one (A2). */
export const AVAILABILITY_STATUSES = {
  AVAILABLE: "available",
  LIMITED: "limited",
  FULLY_BOOKED: "fully_booked",
  NOT_AVAILABLE: "not_available"
}

/** Legend order, matching the design left to right. */
export const LEGEND_STATUSES = [
  { status: AVAILABILITY_STATUSES.AVAILABLE, labelKey: "availability.legend_available", labelDefault: "Available" },
  { status: AVAILABILITY_STATUSES.FULLY_BOOKED, labelKey: "availability.legend_fully_booked", labelDefault: "Fully booked" },
  { status: AVAILABILITY_STATUSES.LIMITED, labelKey: "availability.legend_limited", labelDefault: "Limited availability" },
  { status: AVAILABILITY_STATUSES.NOT_AVAILABLE, labelKey: "availability.legend_not_available", labelDefault: "Not available" }
]

/** Reason types from the contract (§2). Blackout-ish ones render as a solid scope pill. */
export const REASON_TYPES = {
  CREW_SHARED: "crew_shared",
  RESOURCE_SHARED: "resource_shared",
  BLACKOUT: "blackout",
  CREW_OFF: "crew_off",
  FULLY_BOOKED: "fully_booked"
}

/** How many start times the collapsed cell lists before "+N more". */
export const VISIBLE_SLOT_COUNT = 3

export const LISTING_TYPES = { TICKETED: "ticketed" }

export const DATE_KEY_FORMAT = "YYYY-MM-DD"
export const MONTH_LABEL_FORMAT = "MMMM YYYY"
export const SLOT_VALUE_FORMAT = "HH:mm"
export const SLOT_DISPLAY_FORMAT = "hh:mm A"
